import { Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import IndividualSamskars from './individualSamskars';
import WeeklyMonthlySerrvices from './weeklyMonthlySerrvices';
import PaidSevas from './paidSevas';
import AbishekaSponsorship from './abishekaSponsorship';
import styles from '../Information.module.scss';

const PoojaItemsTabComponent = () => {
    const [activeButton, setActiveButton] = useState<string | null>(null);
    const handleSamskarClick = () => {
        setActiveButton('Individual Samskars');
    };
    const handleWeeklyMonthservicesClick = () => {
        setActiveButton('Weekly / MonthlyServices');
    }
    const handlePaidSevasClick = () => {
        setActiveButton('Paid Sevas');
    }
    const handleSponsorshipClick = () => {
        setActiveButton('AbhisekhaSponsorship');
    }
    useEffect(() => {
        setActiveButton('Individual Samskars');
    }, [])


    return (
        <>
            <div className={styles.PoojaItemsTabComponent}>
                <Typography className={styles.typoGraphyHeading}>Pooja Item</Typography>
                <div style={{ marginTop: "20px" }}>
                    <div>
                        <div className={styles.buttonContainer}>
                            <Button
                                onClick={handleSamskarClick}
                                className={activeButton === 'Individual Samskars' ? `${styles.activeButton}` : ''}
                            ><span style={{ textTransform: 'none' }}>Individual Samskaras</span></Button>
                            <Button
                                className={activeButton === 'Weekly / MonthlyServices' ? styles.activeButton : ''}
                                onClick={handleWeeklyMonthservicesClick}><span style={{ textTransform: 'none' }}>Weekly / Monthly Services</span></Button>
                            <Button
                                className={activeButton === 'Paid Sevas' ? styles.activeButton : ''}
                                onClick={handlePaidSevasClick}
                            ><span style={{ textTransform: 'none' }}>Paid Sevas</span></Button>
                            <Button
                                className={activeButton === 'AbhisekhaSponsorship' ? styles.activeButton : ''}
                                onClick={handleSponsorshipClick}><span style={{ textTransform: 'none' }}>Abhisekha Sponsorship</span></Button>
                        </div>

                    </div>
                    <div style={{ borderBottom: '2px solid #D4E2EA' }}></div>
                </div>
            </div>
            {activeButton === 'Individual Samskars' && <IndividualSamskars />}
            {activeButton === 'Weekly / MonthlyServices' && <WeeklyMonthlySerrvices />}
            {activeButton === 'Paid Sevas' && <PaidSevas />}
            {activeButton === 'AbhisekhaSponsorship' && <AbishekaSponsorship />}
        </>
    )
}
export default PoojaItemsTabComponent;